import { render } from "./ConstructorProducerMaker.vue?vue&type=template&id=a85e8922"
import script from "./ConstructorProducerMaker.vue?vue&type=script&lang=js"
export * from "./ConstructorProducerMaker.vue?vue&type=script&lang=js"
script.render = render

export default script